/**
 * BuddyPress components.
 */
import AutoCompleter from './autocompleter';

export default {
	AutoCompleter,
};
